(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(sectionEl) {
      var root = sectionEl.querySelector('[data-shb-problem]');
      if (!root || root.__shbInit) return;
      var track = root.querySelector('[data-shb-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-shb-card]'));
      var links = Array.prototype.slice.call(root.querySelectorAll('[data-shb-link]'));
      if (!track || !cards.length) return;
      root.__shbInit = true;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animate = root.dataset.animate === 'true';

      function showAll() {
        cards.forEach(function (c) { c.style.opacity = 1; c.style.transform = 'none'; });
        links.forEach(function (l) { l.style.transform = 'scaleX(1)'; });
        track.style.transform = 'none';
      }

      if (reduce || !animate || !window.SHBLib) { showAll(); return; }

      window.SHBLib.whenReady(['gsap', 'ScrollTrigger'], function () {
        var g = window.gsap, ST = window.ScrollTrigger;
        g.registerPlugin(ST);

        var stagger = parseFloat(root.dataset.stagger) || 1.7;
        var scrub = parseFloat(root.dataset.scrub) || 0.6;
        var mm = g.matchMedia();

        mm.add('(min-width: 761px)', function () {
          var fits = root.offsetHeight <= window.innerHeight - 8;
          g.set(links, { scaleX: 0, transformOrigin: 'left center' });
          g.set(cards, { opacity: 0, y: 40 });

          var tl = g.timeline({
            defaults: { ease: 'power2.out' },
            scrollTrigger: {
              trigger: root,
              start: fits ? 'top top' : 'top 80%',
              end: fits ? function () { return '+=' + Math.round(window.innerHeight * 1.5); } : 'bottom 45%',
              scrub: scrub,
              pin: fits ? root : false,
              anticipatePin: 1,
              invalidateOnRefresh: true
            }
          });

          cards.forEach(function (card, i) {
            var at = i * stagger;
            tl.fromTo(card, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1, immediateRender: true }, at);
            if (links[i]) {
              tl.fromTo(links[i], { scaleX: 0 }, { scaleX: 1, duration: 0.7, ease: 'none', immediateRender: true }, at + 1);
            }
          });

          return function () { showAll(); };
        });

        mm.add('(max-width: 760px)', function () {
          g.set(cards, { opacity: 1, y: 0 });
          var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth + 20); };

          var drive = g.to(track, {
            x: function () { return -dist(); },
            ease: 'none',
            scrollTrigger: {
              trigger: root,
              start: 'top top',
              end: function () { return '+=' + dist(); },
              scrub: 1,
              pin: true,
              anticipatePin: 1,
              invalidateOnRefresh: true
            }
          });

          var subs = cards.map(function (card) {
            return g.from(card, {
              opacity: 0.4, scale: 0.94, immediateRender: false,
              scrollTrigger: { trigger: card, containerAnimation: drive, start: 'left 90%', end: 'left 60%', scrub: true }
            });
          });

          return function () {
            if (drive.scrollTrigger) drive.scrollTrigger.kill();
            drive.kill();
            subs.forEach(function (sb) { if (sb.scrollTrigger) sb.scrollTrigger.kill(); sb.kill(); });
            showAll();
          };
        });

        root.__shbCleanup = function () { try { mm.revert(); } catch (e) {} showAll(); };
      });
    }

    function initAll() {
      document.querySelectorAll('.shb-problem').forEach(function (el) {
        init(el.closest('.shopify-section') || el.parentNode);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-shb-problem]');
      if (root && root.__shbCleanup) root.__shbCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, format) {
      var v = (cents / 100).toFixed(2);
      if (format && format.indexOf('{{') !== -1) {
        return format.replace(/\{\{\s*amount\s*\}\}/, v)
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
      }
      return '$' + v;
    }

    function init(sectionEl) {
      var root = sectionEl.querySelector('[data-shb-product]');
      if (!root || root.__shbInit) return;
      root.__shbInit = true;

      var fmt = root.dataset.moneyFormat || '${{amount}}';
      var dataEl = root.querySelector('[data-shb-variant-data]');
      var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
      var variantInput = root.querySelector('[data-shb-variant-input]');
      var planInput = root.querySelector('[data-shb-plan-input]');
      var addPrice = root.querySelector('[data-shb-add-price]');

      var state = {
        variantId: variantInput ? String(variantInput.value) : null,
        plan: planInput ? String(planInput.value || '') : ''
      };

      function variant() {
        for (var i = 0; i < data.variants.length; i++) {
          if (String(data.variants[i].id) === String(state.variantId)) return data.variants[i];
        }
        return data.variants[0];
      }

      function priceFor(v, plan) {
        if (!v) return 0;
        if (plan && v.plans && v.plans[plan]) return v.plans[plan].price;
        return v.price;
      }

      function render() {
        var v = variant();
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (planInput) planInput.value = state.plan;

        var price = priceFor(v, state.plan);
        if (addPrice) addPrice.textContent = money(price, fmt);

        root.querySelectorAll('[data-shb-pack]').forEach(function (b) {
          b.classList.toggle('is-selected', String(b.dataset.variantId) === String(v.id));
        });
        root.querySelectorAll('[data-shb-plan]').forEach(function (b) {
          b.classList.toggle('is-selected', String(b.dataset.sellingPlan || '') === String(state.plan));
          var pe = b.querySelector('[data-shb-plan-price]');
          if (pe) {
            var p = b.dataset.sellingPlan || '';
            pe.textContent = money(priceFor(v, p), fmt);
          }
        });

        document.dispatchEvent(new CustomEvent('shb:product:price', {
          detail: {
            sectionId: root.dataset.sectionId,
            variantId: v.id,
            sellingPlan: state.plan,
            price: price,
            priceFormatted: money(price, fmt),
            available: v.available
          }
        }));
      }

      root.querySelectorAll('[data-shb-pack]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          state.variantId = b.dataset.variantId;
          render();
        });
      });
      root.querySelectorAll('[data-shb-plan]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.plan = b.dataset.sellingPlan || '';
          render();
        });
      });

      root.querySelectorAll('[data-shb-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var main = root.querySelector('[data-shb-main-image]');
          if (main) main.src = t.dataset.full;
          root.querySelectorAll('[data-shb-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });

      /* let the sticky ATC submit this form */
      document.addEventListener('shb:sticky:add', function (e) {
        if (e.detail && e.detail.sectionId && e.detail.sectionId !== root.dataset.sectionId) return;
        var form = root.querySelector('[data-shb-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('.shb-product').forEach(function (el) {
        init(el.closest('.shopify-section') || el.parentNode);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(sectionEl) {
      var el = sectionEl.querySelector('[data-shb-reviews]');
      if (!el || el.__shbInit) return;
      if (el.dataset.enable !== 'true') return;
      el.__shbInit = true;
      var perPage = parseInt(el.dataset.perPage, 10) || 3;

      function build() {
        if (!window.Splide) return false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var splide = new window.Splide(el, {
          type: 'loop', drag: 'free', perPage: perPage, perMove: 1,
          gap: '18px', arrows: false, pagination: false,
          padding: { left: '0px', right: '12vw' },
          breakpoints: {
            1400: { perPage: perPage, padding: { left: '0px', right: '10vw' } },
            1100: { perPage: 2, padding: { left: '0px', right: '14vw' } },
            760: { perPage: 1, padding: { left: '0px', right: '22vw' } }
          },
          autoScroll: { speed: reduce ? 0 : 0.35, pauseOnHover: true, pauseOnFocus: false }
        });
        splide.mount(window.splide ? window.splide.Extensions : {});
        if (reduce && splide.Components.AutoScroll) splide.Components.AutoScroll.pause();
        el.__shbSplide = splide;
        return true;
      }

      if (window.SHBLib) {
        window.SHBLib.whenReady(['Splide'], function () {
          if (!build()) {
            var t = setInterval(function () { if (build()) clearInterval(t); }, 80);
            setTimeout(function () { clearInterval(t); }, 8000);
          }
        });
      } else {
        build();
      }
    }

    function initAll() {
      document.querySelectorAll('.shb-reviews').forEach(function (el) {
        init(el.closest('.shopify-section') || el.parentNode);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-shb-reviews]');
      if (el && el.__shbSplide) { try { el.__shbSplide.destroy(true); } catch (x) {} }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(sectionEl) {
      var root = sectionEl.querySelector('[data-shb-science]');
      if (!root || root.__shbInit) return;
      root.__shbInit = true;
      var modal = root.querySelector('[data-shb-ing-modal]');
      var panels = root.querySelectorAll('[data-shb-ing-panel]');
      if (!modal) return;
      var lastFocus = null;

      function open(i) {
        panels.forEach(function (p) { p.hidden = String(p.dataset.shbIngPanel) !== String(i); });
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        lastFocus = document.activeElement;
        var close = modal.querySelector('.shb-science__close');
        if (close) close.focus();
      }
      function close() {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      root.querySelectorAll('[data-shb-ing-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { open(btn.dataset.shbIngOpen); });
      });
      modal.querySelectorAll('[data-shb-ing-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }

    function initAll() {
      document.querySelectorAll('.shb-science').forEach(function (el) {
        init(el.closest('.shopify-section') || el.parentNode);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(sectionEl) {
      var root = sectionEl.querySelector('[data-shb-sticky]');
      if (!root || root.__shbInit) return;
      root.__shbInit = true;

      var bar = root.querySelector('[data-shb-sticky-bar]');
      var mode = root.dataset.triggerMode || 'element';
      var threshold = parseInt(root.dataset.scrollThreshold, 10) || 900;
      var selector = root.dataset.watchSelector || '.shb-section--trust';
      var targetSection = root.dataset.targetProductSection || '';

      var variantInput = root.querySelector('[data-shb-sticky-variant]');
      var planInput = root.querySelector('[data-shb-sticky-plan]');
      var priceEls = root.querySelectorAll('[data-shb-sticky-price], [data-shb-sticky-pill-price]');

      function setState(isBar) {
        root.classList.toggle('is-bar', isBar);
        root.classList.toggle('is-pill', !isBar);
      }
      setState(false);

      /* --- trigger --- */
      if (mode === 'scroll') {
        var onScroll = function () {
          setState((window.scrollY || document.documentElement.scrollTop || 0) > threshold);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        var watched = document.querySelector(selector);
        if (!watched) {
          /* nothing to watch — behave like the pill until scrolled a bit */
          var fb = function () { setState((window.scrollY || 0) > threshold); };
          window.addEventListener('scroll', fb, { passive: true });
          fb();
        } else if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              /* bar once the watched element's bottom has scrolled above the viewport */
              setState(e.boundingClientRect.bottom <= 0);
            });
          }, { threshold: [0], rootMargin: '0px 0px -100% 0px' });
          io.observe(watched);
          /* also re-check on scroll for the "scrolled back up" case */
          window.addEventListener('scroll', function () {
            setState(watched.getBoundingClientRect().bottom <= 0);
          }, { passive: true });
        }
      }

      /* --- price/variant sync from the product section --- */
      document.addEventListener('shb:product:price', function (e) {
        var d = e.detail || {};
        if (targetSection && d.sectionId && String(d.sectionId) !== String(targetSection)) return;
        if (variantInput && d.variantId) variantInput.value = d.variantId;
        if (planInput) planInput.value = d.sellingPlan || '';
        priceEls.forEach(function (el) { if (d.priceFormatted) el.textContent = d.priceFormatted; });
      });

      /* --- sticky bar submit: also try to route through the product section --- */
      var form = root.querySelector('[data-shb-sticky-form]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          /* if a product section is present, let it own the submit for consistent UX */
          var hasProductSection = document.querySelector('[data-shb-product] [data-shb-form]');
          if (hasProductSection) {
            ev.preventDefault();
            document.dispatchEvent(new CustomEvent('shb:sticky:add', { detail: { sectionId: targetSection } }));
          }
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-shb-sticky]').forEach(function (el) {
        init(el.closest('.shopify-section') || el.parentNode);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
